import axios from 'axios';
import { encodeEnvelope } from './credentialCodec';

const client = axios.create();

// Methods whose JSON body we hex-wrap before sending.
const WRAPPED_METHODS = new Set(['post', 'put', 'patch', 'delete']);

// Only wrap genuine JSON payloads plain objects. Leaves FormData, Blobs,
// arrays, strings and empty bodies untouched.
function isPlainObject(value) {
  if (value === null || typeof value !== 'object') return false;
  const proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
}

client.interceptors.request.use((config) => {
  const next = { ...config };

  if (!next.headers) {
    next.headers = {};
  }

  if (!next.skipAuth) {
    const token = localStorage.getItem('token');
    if (token && !next.headers.Authorization) {
      next.headers.Authorization = `Bearer ${token}`;
    }
  }

  // Hex-wrap the request body so Bunny Shield's WAF (which counts special
  // characters across the whole body) only ever sees `{"d":"<hex>"}`. The
  // backend unwraps it via the unwrapEnvelope middleware. See credentialCodec.
  const method = (next.method || 'get').toLowerCase();
  if (WRAPPED_METHODS.has(method) && isPlainObject(next.data)) {
    next.data = encodeEnvelope(next.data);
  }

  return next;
});

export default client;
